export default __webpack_public_path__ + "faaaff50fc10527593b5f98470f333c3.png";